import styled, { StyledComponent } from 'styled-components';
import { StyledIconPropsWithOrientation } from './icons';

export const SvgContainerWithOrientation = (
  orientationMap: Record<string, string>
): StyledComponent<'svg', any, any, never> => styled.svg<StyledIconPropsWithOrientation>`
  transform: ${({ $orientation }) => orientationMap[$orientation]};
`;
